export enum TransactionType {
	Unlock = "Unlock",
	Deposit = "Deposit",
	Refund = "Refund",
	Gift = "Gift"
}